import { CrownFilled, LikeFilled } from '@ant-design/icons'
import { Avatar, Badge, List, Tabs, Typography } from 'antd'
import cls from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { DepartmentsDisplay, UserHoverCard } from '@/components'
import { useGetLikedUsersQuery } from '@/generated/graphql'
import { routes } from '@/routes'

import s from './trending.module.less'

const { TabPane } = Tabs

interface rankListProps {
  timeSpan: number
}

export const LikedUserRank: React.FC = () => {
  const { t } = useTranslation()
  const [tab, setTab] = React.useState<string>('week')

  const footer = (
    <div className={s.footer}>
      <Tabs
        animated={false}
        tabPosition={'bottom'}
        activeKey={tab}
        size={'small'}
        tabBarGutter={8}
        onChange={(tab) => setTab(tab)}
      >
        <TabPane tab={t('filter.week')} key='week' />
        <TabPane tab={t('filter.month')} key='month' />
        <TabPane tab={t('filter.season')} key='season' />
        <TabPane tab={t('filter.year')} key='year' />
      </Tabs>
    </div>
  )

  const timespan = {
    week: 7,
    month: 30,
    season: 90,
    year: 365,
  }[tab]

  const contents = (() => {
    return <LikedUserList timeSpan={timespan!} />
  })()

  return (
    <>
      <Typography.Title level={4}>
        <LikeFilled style={{ color: '#7331D6' }} /> {t('trend.likedRank')}
      </Typography.Title>
      <div className={s.listContainer}>
        {contents}
        {footer}
      </div>
    </>
  )
}

export const LikedUserList: React.FC<rankListProps> = ({ timeSpan }) => {
  const { data, loading, error } = useGetLikedUsersQuery({
    variables: {
      timeSpan: timeSpan,
      pagination: {
        first: 8,
      },
    },
  })

  if (error) {
    return null
  }

  const users = data ? data.recommend.usersRankedByLikes.edges.map(({ node }) => node) : []

  return (
    <List
      dataSource={users}
      loading={loading}
      split={false}
      renderItem={(u) => (
        <List.Item key={u.userId}>
          <Typography.Title style={{ color: '#7331D6' }} level={4}>
            {users.indexOf(u) + 1 + '.'}
          </Typography.Title>
          <List.Item.Meta
            avatar={
              <Badge
                count={
                  <div
                    className={cls(s.icon, {
                      [s.icon1]: users.indexOf(u) == 0,
                      [s.icon2]: users.indexOf(u) == 1,
                      [s.icon3]: users.indexOf(u) == 2,
                    })}
                  >
                    {users.indexOf(u) < 3 && <CrownFilled />}
                  </div>
                }
                offset={[-32, 0]}
              >
                <Avatar src={u.avatarUrl} style={{ marginLeft: 20 }} />
              </Badge>
            }
            title={
              <UserHoverCard email={u.email}>
                <Link to={routes.users.page(u.email)}>{u.name}</Link>
              </UserHoverCard>
            }
            description={<DepartmentsDisplay departments={u.departments} />}
          />
        </List.Item>
      )}
    />
  )
}
